import { gql } from "@apollo/client";

export const GET_ALL_PRODUCTS = gql`
  query GetAllProducts(
    $page: Int
    $perPage: Int
    $orderBy: String
    $categoryName: String
    $search: String
    $filters: [FilterInputType!]
    $entityId: String!
  ) {
    getAllProducts(
      page: $page
      perPage: $perPage
      orderBy: $orderBy
      categoryName: $categoryName
      search: $search
      filters: $filters
      entityId: $entityId
    ) {
      data {
        id
        productName
        partNumber
        size
        mrp
        globalSku
        description
        isLooseItem
        images {
          fileCategoryName
          fileCategoryDisplayName
          fileUrl
          fileName
        }
        isAvailableGlobally
        createdByEntityId
        category {
          id
          categoryName
          categoryDisplayName
        }
        brand {
          brandType {
            brandTypeName
            brandTypeDisplayName
          }
          brandName
          id
        }
        sizeUnit {
          sizeUnitName
          sizeUnitDisplayName
        }
        customFields {
          values
          fieldTypeName
          fieldTypeDisplayName
          isMultiple
        }
        customFieldsV2 {
          values {
            fieldValue
            isVerified
          }
          fieldTypeName
          fieldTypeDisplayName
          isMultiple
        }
      }
      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const ADD_PRODUCT = gql`
  mutation AddProduct($product: AddProductInput!) {
    addProduct(product: $product) {
      product {
        id
        productName
        partNumber
        size
        packingType
        mrp
        globalSku
        isAvailableGlobally
        createdByEntityId
        brand {
          id
          brandName
        }
        customFields {
          values
          fieldTypeName
          fieldTypeDisplayName
          isMultiple
        }
        sizeUnit {
          sizeUnitName
          sizeUnitDisplayName
        }
      }
    }
  }
`;

export const GET_ALL_BRAND = gql`
  query GetAllBrands($perPage: Int, $filters: [FilterInputType!]) {
    getAllBrands(perPage: $perPage, filters: $filters) {
      data {
        id
        brandName
      }
    }
  }
`;

export const GET_ALL_UNITS = gql`
  query GetAllSizeUnits {
    getAllSizeUnits {
      data {
        sizeUnitName
        sizeUnitDisplayName
      }
    }
  }
`;

export const GET_PRODUCT_BY_ID = gql`
  query GetProductById($id: ID, $entityId: String!) {
    getProduct(id: $id, entityId: $entityId) {
      id
      productName
      partNumber
      hsn
      size
      mrp
      globalSku
      description
      packingType
      isLooseItem
      images {
        fileCategoryName
        fileCategoryDisplayName
        fileUrl
        fileName
        fileUploadSlug
      }
      isAvailableGlobally
      createdByEntityId
      category {
        id
        categoryName
        categoryDisplayName
      }
      brand {
        brandName
        id
      }
      sizeUnit {
        sizeUnitName
        sizeUnitDisplayName
      }
      measurementUnit
      customFields {
        values
        fieldTypeName
        fieldTypeDisplayName
        isMultiple
      }
      customFieldsV2 {
        values {
          fieldValue
          isVerified
        }
        fieldTypeName
        fieldTypeDisplayName
        isMultiple
      }
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($product: UpdateProductInput!) {
    updateProduct(product: $product) {
      product {
        id
        productName
        partNumber
        size
        mrp
        globalSku
        isAvailableGlobally
        createdByEntityId
        brand {
          id
          brandName
        }
        customFields {
          values
          fieldTypeName
          fieldTypeDisplayName
          isMultiple
        }
        sizeUnit {
          sizeUnitName
          sizeUnitDisplayName
        }
      }
    }
  }
`;

export const GET_ALL_CATEGORIES = gql`
  query GetAllCategories {
    getAllCategories {
      categoryName
      categoryDisplayName
      isLeaf
      childCategories {
        categoryName
        categoryDisplayName
        isLeaf
        childCategories {
          categoryName
          categoryDisplayName
          isLeaf
          childCategories {
            categoryName
            categoryDisplayName
            isLeaf
            childCategories {
              categoryName
              categoryDisplayName
              isLeaf
              childCategories {
                categoryName
                categoryDisplayName
                isLeaf
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ENTITIES = gql`
  query getEntity {
    getEntities {
      id
      entityName
      entityDisplayName
      #      childEntities {
      #        id
      #        entityName
      #        entityDisplayName
      #      }
      isDefaultEntity
      defaultReceiveLocation {
        id
      }
      invoiceFeatureVisible
      nonSortingEntities {
        id
      }
    }
  }
`;

export const GET_INVENTORY_LISTING = gql`
  query GetAllInventory(
    $entityId: String!
    $page: Int
    $perPage: Int
    $search: String
  ) {
    getAllInventories(
      entityId: $entityId
      page: $page
      perPage: $perPage
      search: $search
    ) {
      data {
        id
        quantity
        entity {
          id
          entityName
        }
        location {
          id
          locationName
          locationDisplayName
        }
        product {
          id
          partNumber
          productName
          size
          isLooseItem
          mrp
          globalSku
          isAvailableGlobally
          createdByEntityId
          category {
            id
            categoryName
            categoryDisplayName
          }
          brand {
            id
            brandName
          }
        }
      }
      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const ADD_INVENTORY = gql`
  mutation AddInventory(
    $productId: String!
    $locationId: String!
    $quantity: Int!
  ) {
    addInventory(
      data: {
        productId: $productId
        locationId: $locationId
        quantity: $quantity
      }
    ) {
      success
      inventory {
        id
        quantity
        location {
          id
          locationName
          locationDisplayName
        }
        product {
          id
          productName
        }
      }
      skuIds
    }
  }
`;

export const INVENTORY_STOCK_IN = gql`
  mutation InventoryStockIn(
    $inventoryStockInInput: InventoryStockInInput!
    $entityId: String!
  ) {
    inventoryStockIn(data: $inventoryStockInInput, entityId: $entityId) {
      success
      inventory {
        id
        quantity
        entity {
          id
          entityName
        }
        location {
          id
          locationName
          locationDisplayName
        }
      }
      skuIds
    }
  }
`;

export const INVENTORY_STOCK_OUT = gql`
  mutation InventoryStockOut(
    $inventoryStockOutInput: InventoryStockOutInput!
    $entityId: String!
  ) {
    inventoryStockOut(data: $inventoryStockOutInput, entityId: $entityId) {
      success
      inventory {
        id
        quantity
        entity {
          id
          entityName
        }
        location {
          id
          locationName
          locationDisplayName
        }
      }
    }
  }
`;

export const MOVE_STOCK = gql`
  mutation MoveInventoryStock($data: MoveInventoryInput!, $entityId: String!) {
    inventoryMovement(data: $data, entityId: $entityId) {
      success
      fromInventory {
        id
        quantity
        entity {
          id
          entityName
        }
        location {
          id
          locationName
        }
        product {
          id
          partNumber
          productName
          size
          mrp
          globalSku
          isAvailableGlobally
          createdByEntityId
          category {
            categoryName
            categoryDisplayName
          }
          brand {
            brandName
          }
        }
      }
      toInventory {
        id
        quantity
        entity {
          id
          entityName
        }
        location {
          id
          locationName
        }
        product {
          id
          partNumber
          productName
          size
          mrp
          globalSku
          isAvailableGlobally
          createdByEntityId
          category {
            categoryName
            categoryDisplayName
          }
          brand {
            brandName
          }
        }
      }
    }
  }
`;
export const GET_LOCATIONS = gql`
  query GetLocation($entityId: String!) {
    getLocations(entityId: $entityId, perPage: 10000) {
      data {
        id
        locationName
        locationDisplayName
      }
    }
  }
`;

export const GET_LOCATION_TYPES = gql`
  query GetLocationType($entityId: String!) {
    getLocationTypes(entityId: $entityId) {
      id
      locationTypeName
      locationTypeDisplayName
    }
  }
`;

export const ADD_LOCATIONS = gql`
  mutation AddLocation($data: AddLocationInput!, $entityId: String!) {
    addLocation(data: $data, entityId: $entityId) {
      success
    }
  }
`;

export const GET_ALL_REQUESTS = gql`
  query GetAllRequests(
    $page: Int
    $perPage: Int
    $entityId: String!
    $filters: [FilterInputType!]
    $orderBy: String
    $search: String
  ) {
    getAllRequests(
      page: $page
      perPage: $perPage
      entityId: $entityId
      filters: $filters
      orderBy: $orderBy
      search: $search
    ) {
      data {
        id
        slug
        displayName
        status
        createdAt
        action
        sourceId
        source
        requestType
        reason
        action
        createdByUser
        displayParts {
          label
          color
        }
        requestStatus {
          label
          color
        }
        sourceDetails {
          make
          model
          variant
          year
          registrationNo
        }
      }

      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const GET_ALL_DRAFT_REQUESTS = gql`
  query GetAllRequests(
    $page: Int
    $perPage: Int
    $entityId: String!
    $filters: [FilterInputType!]
    $orderBy: String
    $search: String
  ) {
    getAllRequests(
      page: $page
      perPage: $perPage
      entityId: $entityId
      filters: $filters
      orderBy: $orderBy
      search: $search
    ) {
      data {
        id
        slug
        status
        displayName
        action
        sourceId
        source
        reason
        action
        createdByUser
        requestItems {
          quantity
          action
          status
          product {
            id
            productName
            partNumber
            size
            mrp
          }
          receivedQuantity
        }
      }

      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const GET_REQUEST = gql`
  query GetRequest($entityId: String!, $requestId: String!) {
    getRequest(entityId: $entityId, requestId: $requestId) {
      id
      slug
      displayName
      status
      source
      sourceId
      reason
      action
      requestType
      sourceDetails {
        leadId
        make
        model
        variant
        registrationNo
        transmission
        year
        fuelType
      }
      requestItems {
        id
        requestItemToVendor {
          vendor {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          confirmedQuantity
        }
        quantity
        action
        status
        inStockQuantity
        totalConfirmedQuantity
        totalReservedQuantity
        requestItemStatus {
          label
          color
        }
        product {
          id
          productName
          partNumber
          size
          mrp
          isLooseItem
          images {
            fileCategoryName
            fileCategoryDisplayName
            fileUrl
            fileName
          }
          customFields {
            values
            fieldTypeName
            fieldTypeDisplayName
            isMultiple
          }
          brand {
            id
            brandName
          }
        }
        requests {
          id
          source
          sourceId
          slug
          sourceDetails {
            leadId
            make
            model
            variant
            registrationNo
            transmission
            year
            fuelType
          }
        }
        requestItems {
          id
          receivedQuantity
        }
        receivedQuantity
      }
    }
  }
`;

export const GET_ISSUE_RAISE_REQUEST = gql`
  query GetRequest($entityId: String!, $requestId: String!) {
    getRequest(entityId: $entityId, requestId: $requestId) {
      id
      slug
      displayName
      status
      source
      sourceId
      reason
      action
      requestType
      sourceDetails {
        leadId
        make
        model
        variant
        registrationNo
        transmission
        year
        fuelType
      }
      requestItems {
        id
        vendors {
          id
          name
          contactDetails {
            id
            name
            contactNumber
          }
        }
        quantity
        action
        status
        inStockQuantity
        totalConfirmedQuantity
        totalReservedQuantity
        product {
          id
          productName
          partNumber
          size
          mrp
          isLooseItem
          customFields {
            values
            fieldTypeName
            fieldTypeDisplayName
            isMultiple
          }
          brand {
            id
            brandName
          }
        }
        requests {
          id
          source
          sourceId
          slug
          sourceDetails {
            leadId
            make
            model
            variant
            registrationNo
            transmission
            year
            fuelType
          }
        }
        requestItems {
          id
          receivedQuantity
        }
        receivedQuantity: issuedQuantity
      }
    }
  }
`;

export const ADD_REQUEST = gql`
  mutation AddRequest($entityId: String!, $request: AddRequestInput!) {
    addRequest(entityId: $entityId, request: $request) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        reason
        action
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            brand {
              id
              brandName
            }
          }
          requests {
            id
            source
            sourceId
            sourceDetails {
              leadId
              make
              model
              variant
              registrationNo
              transmission
              year
              fuelType
            }
          }
          receivedQuantity
        }
      }
    }
  }
`;

export const GET_PRODUCT_LOCATION_INVENTORY = gql`
  query GetAllInventories($entityId: String!, $productId: String) {
    getAllInventories(entityId: $entityId, productId: $productId) {
      data {
        id
        location {
          id
          locationName
          locationDisplayName
        }
        quantity
      }
    }
  }
`;

export const RECEIVE_REQUEST_ITEM = gql`
  mutation ReceiveRequestItem(
    $entityId: String!
    $receiveRequestItems: [ReceiveRequestItemInput!]!
    $requestId: String!
  ) {
    receiveRequestItem(
      entityId: $entityId
      receiveRequestItems: $receiveRequestItems
      requestId: $requestId
    ) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        reason
        action
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
          }
          receivedQuantity
        }
      }
      skuIds {
        productId
        product {
          id
          productName
        }
        skuIds
      }
    }
  }
`;

export const GET_INVENTORY_BY_PRODUCTS = gql`
  query GetInventoryByProducts($entityId: String!, $productIds: [String!]!) {
    getInventoryByProducts(entityId: $entityId, productIds: $productIds) {
      productId
      inStockQuantity
      availableQuantity
    }
  }
`;

export const INVENTORY_MOVEMENT = gql`
  mutation InventoryMovement($data: MoveInventoryInput!, $entityId: String!) {
    inventoryMovement(data: $data, entityId: $entityId) {
      success
      fromInventory {
        id
      }
      toInventory {
        id
      }
      skuIds
    }
  }
`;

export const GET_PRODUCT_SKU_LISTING = gql`
  query GetProductSKUListing(
    $entityId: String!
    $productId: String!
    $locationId: String
  ) {
    getProductSkus(
      entityId: $entityId
      productId: $productId
      locationId: $locationId
    ) {
      product {
        id
        mrp
        isConsumable
        brand {
          id
          brandType {
            brandTypeName
            brandTypeDisplayName
          }
          brandName
        }
      }
      skuList {
        skuId
        quantity
        price
        sellingPrice
        issuedQuantity
        createdAt
        reservationStatus
        reserveredRequestItemId
        reservedRequestId
        initialQuantity
        isValidForIssuing
        reservationDetails {
          leadId
          make
          model
          year
          variant
          registrationNo
        }
        location {
          id
          locationDisplayName
        }
        vendor {
          id
          name
        }
        isSkuSelectable
        isSkuSelectableStockOut
        isSkuSelectableChangeLocation
      }
    }
  }
`;

export const GET_PRODUCT_SKU_FOR_ISSUE_REQUEST_ITEM_RETURN = gql`
  query GetProductSKUForIssueRequestItemReturn(
    $entityId: String!
    $requestItemId: String!
  ) {
    getProductSkusForIssueRequestItemReturn(
      entityId: $entityId
      requestItemId: $requestItemId
    ) {
      product {
        id
        mrp
        brand {
          id
          brandName
        }
      }
      skuList {
        skuId
        quantity
        price
        sellingPrice
        issuedQuantity
        createdAt
        reservationStatus
        skuReturnVerdict
        reservationDetails {
          leadId
          make
          model
          year
          variant
          registrationNo
        }
        location {
          id
          locationDisplayName
        }
        vendor {
          id
          name
        }
      }
    }
  }
`;

export const GET_PRODUCT_SKUS_FOR_ISSUE_REQUEST_ITEMS = gql`
  query GetProductSkusForIssueRequestItems(
    $entityId: String!
    $requestItemIds: [String!]!
  ) {
    getProductSkusForIssueRequestItems(
      entityId: $entityId
      requestItemIds: $requestItemIds
    ) {
      productSkuTypeList {
        product {
          id
          partNumber
          productName
          mrp
          brand {
            id
            brandType {
              brandTypeName
              brandTypeDisplayName
            }
            brandName
          }
        }
        skuList {
          skuId
          reserveredRequestItemId
          quantity
          price
          sellingPrice
          issuedQuantity
          isValidForIssuing
          location {
            id
            locationDisplayName
          }
          vendor {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_SKUS_FOR_ISSUE_REQUEST_ITEM = gql`
  query GetProductSKUSForIssueRequestItem(
    $entityId: String!
    $requestItemId: String!
  ) {
    getProductSkusForIssueRequestItem(
      entityId: $entityId
      requestItemId: $requestItemId
    ) {
      product {
        id
        mrp
        brand {
          id
          brandType {
            brandTypeName
            brandTypeDisplayName
          }
          brandName
        }
      }
      skuList {
        skuId
        quantity
        price
        sellingPrice
        issuedQuantity
        isValidForIssuing
        location {
          id
          locationDisplayName
        }
        vendor {
          id
          name
        }
      }
    }
  }
`;

export const GET_PRODUCT_SKUS_FOR_LOOSE_ISSUE_REQUEST_ITEM_RETURN = gql`
  query GetProductSKUSForLooseIssueRequestItemReturn(
    $entityId: String!
    $requestItemId: String!
  ) {
    getProductSkusForLooseIssueRequestItemReturn(
      entityId: $entityId
      requestItemId: $requestItemId
    ) {
      product {
        id
        mrp
        brand {
          id
          brandName
        }
      }
      skuList {
        skuId
        parentSkuId
        quantity
        price
        sellingPrice
        issuedQuantity
        skuReturnVerdict
        location {
          id
          locationDisplayName
        }
        vendor {
          id
          name
        }
      }
    }
  }
`;

export const SUBMIT_QC_WRONG_PART_RETURN = gql`
  mutation SubmitQcWrongPartReturn(
    $requestNSource: String!
    $productId: String!
    $sku: String!
    $reason: String!
    $fileUrl: String!
  ) {
    submitQcWrongPartReturn(requestNSource: $requestNSource, productId: $productId, sku: $sku, reason: $reason, fileUrl: $fileUrl) {
      success
    }
  }
`;


export const ISSUE_REQUEST_ITEMS_V2 = gql`
  mutation IssueRequestItemV2(
    $entityId: String!
    $issueRequestItems: [IssueRequestItemInput]!
    $requestId: String!
  ) {
    issueRequestItemV2(
      entityId: $entityId
      issueRequestItems: $issueRequestItems
      requestId: $requestId
    ) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        reason
        action
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
          }
          receivedQuantity
        }
      }
      alreadyReceivedSkus
    }
  }
`;

export const ISSUE_REQUEST_ITEM = gql`
  mutation IssueRequestItems(
    $entityId: String!
    $issueRequestItems: IssueRequestItemInput!
    $requestId: String!
  ) {
    issueRequestItem(
      entityId: $entityId
      issueRequestItems: $issueRequestItems
      requestId: $requestId
    ) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        reason
        action
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
          }
          receivedQuantity
        }
      }
    }
  }
`;

export const ADD_REQUEST_ITEM_TO_VENDOR = gql`
  mutation AddRequestItemToVendor(
    $entityId: String!
    $requestItemIds: [String!]!
    $vendor: VendorInputType!
  ) {
    addRequestItemToVendor(
      entityId: $entityId
      requestItemIds: $requestItemIds
      vendor: $vendor
    ) {
      success
      requestItemToVendor {
        id
        vendor {
          id
          name
        }
        requestItem {
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          product {
            id
          }
        }
      }
    }
  }
`;

export const GET_ALL_VENDORS = gql`
  query vendors($perPage: Int) {
    getAllVendors(perPage: $perPage) {
      data {
        id
        name
      }
    }
  }
`;

export const EDIT_NOTE_FOR_VENDOR = gql`
  mutation UpdateRequestItemToVendor(
    $entityId: String!
    $requestItemId: String!
    $vendorId: String!
    $notes: String!
    $confirmedQuantity: Int
  ) {
    updateRequestItemToVendor(
      entityId: $entityId
      requestItemId: $requestItemId
      vendorId: $vendorId
      notes: $notes
      confirmedQuantity: $confirmedQuantity
    ) {
      success
      requestItemToVendor {
        id
        notes
      }
    }
  }
`;

export const GET_NOTE_FOR_VENDOR = gql`
  query getRequestItemsToVendor($requestItemId: String!, $vendorId: String!) {
    getRequestItemToVendor(requestItemId: $requestItemId, vendorId: $vendorId) {
      id
      requestItem {
        id
      }
      confirmedQuantity
      notes
    }
  }
`;

export const RETURN_REQUEST_ITEM = gql`
  mutation ReturnRequestItems(
    $entityId: String!
    $reason: String
    $returnRequestItems: ReturnRequestItemInput!
    $requestId: String!
  ) {
    returnRequestItem(
      entityId: $entityId
      reason: $reason
      returnRequestItems: $returnRequestItems
      requestId: $requestId
    ) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        action
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
          }
          receivedQuantity
        }
      }
    }
  }
`;

export const GET_REQUESTED_VENDORS = gql`
  query GetRequestVend($requestId: String!, $entityId: String!) {
    getRequestToVendors(requestId: $requestId, entityId: $entityId) {
      id
      name
      vendorSlug
    }
  }
`;

export const ADD_ISSUE_REQUEST_ITEM_TO_PURCHASE_REQUEST = gql`
  mutation AddIssueRequestItemToPurchaseRequest(
    $entityId: String!
    $issueRequestItems: [IssueRequestItemQuantityInput!]!
    $purchaseRequestId: String
    $issueRequestId: String!
  ) {
    addIssueRequestItemToPurchaseRequest(
      entityId: $entityId
      issueRequestItems: $issueRequestItems
      purchaseRequestId: $purchaseRequestId
      issueRequestId: $issueRequestId
    ) {
      success
      message
    }
  }
`;

export const GET_REQUEST_USERS = gql`
  query GetRequestUsers($entityId: String!, $action: RequestItemActionEnum) {
    getRequestUsers(entityId: $entityId, action: $action) {
      username
      email
      ssoUserId
    }
  }
`;

export const VIEW_SIMILAR_PRODUCTS = gql`
  query GetSimilarProducts($productId: String, $perPage: Int) {
    getSimilarProducts(productId: $productId, perPage: $perPage) {
      data {
        id
        productName
        partNumber
        size
        globalSku
        isLooseItem
        isAvailableGlobally
        category {
          id
          categoryName
          categoryDisplayName
        }
        brand {
          id
          brandName
        }
        sizeUnit {
          sizeUnitName
          sizeUnitDisplayName
        }
      }
      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const REPLACE_PURCHASE_REQUEST_ITEM = gql`
  mutation ReplacePurchaseRequestItem(
    $entityId: String!
    $requestId: String!
    $requestItemId: String!
    $updatedProductId: String!
  ) {
    replacePurchaseRequestItem(
      entityId: $entityId
      requestId: $requestId
      requestItemId: $requestItemId
      updatedProductId: $updatedProductId
    ) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        reason
        action
        requestType
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            brand {
              id
              brandName
            }
          }
          requests {
            id
            source
            sourceId
            sourceDetails {
              leadId
              make
              model
              variant
              registrationNo
              transmission
              year
              fuelType
            }
          }
          receivedQuantity
        }
      }
    }
  }
`;

export const GET_ALL_INVENTORIES_GROUP_BY_LOCATION = gql`
  query GetAllInventoriesGroupByLocations(
    $entityId: String!
    $page: Int
    $search: String
    $filters: [FilterInputType!]
  ) {
    getAllInventoriesGroupByLocations(
      entityId: $entityId
      page: $page
      search: $search
      filters: $filters
    ) {
      data {
        id
        availableQuantity
        product {
          id
          productName
          partNumber
          isLooseItem
          size
          mrp
          globalSku
          description
          customFields {
            values
            fieldTypeName
            fieldTypeDisplayName
            isMultiple
          }
          images {
            fileCategoryName
            fileCategoryDisplayName
            fileUrl
            fileName
          }
          isAvailableGlobally
          createdByEntityId
          category {
            id
            categoryName
            categoryDisplayName
          }
          brand {
            brandType {
              brandTypeName
              brandTypeDisplayName
            }
            brandName
            id
          }
          sizeUnit {
            sizeUnitName
            sizeUnitDisplayName
          }
          customFields {
            values
            fieldTypeName
            fieldTypeDisplayName
            isMultiple
          }
        }
        locations {
          id
          locationName
          locationDisplayName
        }
        quantity
        minimumQuantity
      }
      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const UPDATE_PRODUCT_MINIMUM_QUANTITY = gql`
  mutation UpdateProductMinimumQuantity(
    $entityId: String!
    $productId: String!
    $minimumQuantity: String!
  ) {
    updateProductMinimumQuantity(
      entityId: $entityId
      productId: $productId
      minimumQuantity: $minimumQuantity
    ) {
      success
      inventory {
        id
        minimumQuantity
      }
    }
  }
`;

export const PRODUCT_STOCK_OUT = gql`
  mutation ProductStockOut($data: ProductStockOutInput!, $entityId: String!) {
    productStockOut(data: $data, entityId: $entityId) {
      success
      inventories {
        product {
          id
        }
        quantity
      }
    }
  }
`;

export const MOVE_PRODUCT_SKU = gql`
  mutation MoveProductSku($data: MoveProductSKUInput!, $entityId: String!) {
    moveProductSku(data: $data, entityId: $entityId) {
      success
      inventories {
        id
        product {
          id
          productName
          partNumber
          isLooseItem
          size
          mrp
          globalSku
          description
          images {
            fileCategoryName
            fileCategoryDisplayName
            fileUrl
            fileName
          }
          isAvailableGlobally
          createdByEntityId
          category {
            id
            categoryName
            categoryDisplayName
          }
          brand {
            brandName
            id
          }
          sizeUnit {
            sizeUnitName
            sizeUnitDisplayName
          }
          customFields {
            values
            fieldTypeName
            fieldTypeDisplayName
            isMultiple
          }
        }
        locations {
          id
          locationName
          locationDisplayName
        }
        quantity
        minimumQuantity
      }
    }
  }
`;

export const GET_REQUEST_ITEMS_VENDOR_DETAILS = gql`
  query GetRequestItemsVendorDetails(
    $entityId: String!
    $requestId: String!
    $vendorId: String!
    $requestItemId: String
  ) {
    getRequestItemsVendorDetails(
      entityId: $entityId
      requestId: $requestId
      vendorId: $vendorId
      requestItemId: $requestItemId
    ) {
      requestItem {
        id
        quantity
        product {
          id
          productName
          mrp
          partNumber
          isLooseItem
        }
        totalConfirmedQuantity
      }
      receivedQuantity
      confirmedQuantity
      maxReceiveQuantity
    }
  }
`;

export const GET_SKU_WISE_RACK_LISTING = gql`
  query GetSkuWiseRackListing(
    $entityId: String!
    $perPage: Int
    $page: Int
    $filters: [FilterInputType!]
    $locationIds: [String]
    $unreservedSkus: Boolean
    $search: String
  ) {
    getAllInventoriesGroupByLocations(
      entityId: $entityId
      perPage: $perPage
      page: $page
      search: $search
      filters: $filters
    ) {
      data {
        id
        product {
          id
          productName
          partNumber
          isLooseItem
        }
        locations: suggestedLocations {
          id
          locationDisplayName
          locationName
        }
        data: productSkus(
          locationIds: $locationIds
          unreservedSkus: $unreservedSkus
        ) {
          skuId
          quantity
          issuedQuantity
          price
          createdAt
        }
      }
      paginator {
        currentPage
        numPages
        totalItems
        perPage
      }
    }
  }
`;

export const EMPTY_STAGING_QUERY = gql`
  query GetEmptyStagingSKUListing(
    $entityId: String!
    $perPage: Int
    $page: Int
    $search: String
  ) {
    getProductSkuListing(
      entityId: $entityId
      page: $page
      perPage: $perPage
      search: $search
      filters: [{ key: "empty_staging", value: "true" }]
    ) {
      paginator {
        totalItems
        perPage
        numPages
        currentPage
      }
      data {
        id
        skuId: sku
        currentLocation {
          id
          locationName
          locationDisplayName
        }
        suggestedLocations {
          id
          locationName
          locationDisplayName
        }
        product {
          id
          partNumber
          productName
          isLooseItem
          brand {
            id
            brandName
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_SKU_LISTING_FOR_DOCUMENT = gql`
  query GetProductSkuListingForDocument(
    $entityId: String!
    $documentId: String!
    $perPage: Int
    $page: Int
    $search: String
  ) {
    getProductSkuListingForDocument(
      entityId: $entityId
      documentId: $documentId
      page: $page
      perPage: $perPage
      search: $search
    ) {
      paginator {
        totalItems
        perPage
        numPages
        currentPage
      }
      data {
        id
        skuId: sku
        currentLocation {
          id
          locationName
          locationDisplayName
        }
        suggestedLocations {
          id
          locationName
          locationDisplayName
        }
        product {
          id
          partNumber
          productName
          isLooseItem
          brand {
            id
            brandName
          }
        }
      }
    }
  }
`;

export const BULK_UPDATE_REQUEST_ITEM_TO_VENDOR = gql`
  mutation BulkUpdateRequestItemToVendor(
    $entityId: String!
    $requestId: String!
    $vendorId: String!
    $requestItemConfirmedQuantity: [RequestItemConfirmedQuantityType]!
  ) {
    bulkUpdateRequestItemToVendor(
      entityId: $entityId
      requestId: $requestId
      vendorId: $vendorId
      requestItemConfirmedQuantity: $requestItemConfirmedQuantity
    ) {
      success
      request {
        id
        requestItems {
          id
          quantity
          status
          inStockQuantity
          totalConfirmedQuantity
          totalReservedQuantity
          receivedQuantity
        }
        requestStatus {
          label
          color
        }
      }
    }
  }
`;

export const BULK_MOVE_PRODUCT_SKU = gql`
  mutation BulkMoveProductSku(
    $entityId: String!
    $data: [MoveProductSKUInput]!
  ) {
    bulkMoveProductSku(data: $data, entityId: $entityId) {
      success
    }
  }
`;

export const MOVE_PRODUCT_SKU_FOR_DOCUMENT = gql`
  mutation MoveProductSkuForDocument(
    $entityId: String!
    $data: [MoveProductSKUInput]!
  ) {
    moveProductSku(data: $data, entityId: $entityId) {
      success
    }
  }
`;

export const GET_REQUEST_INSIGHTS = gql`
  query GetRequestInsights($entityId: String!) {
    getRequestsInsight(entityId: $entityId) {
      data {
        key
        value
        category
      }
    }
  }
`;

export const UPDATE_REQUEST_NODE_ITEM = gql`
  mutation UpdateRequestNodeItem(
    $requestNodeItemId: String!
    $entityId: String!
    $productId: String!
  ) {
    updateRequestNodeItem(
      requestNodeItemId: $requestNodeItemId
      entityId: $entityId
      productId: $productId
    ) {
      success
      request {
        id
        requestItems {
          id
          quantity
          action
          status
          inStockQuantity
          totalConfirmedQuantity
          totalReservedQuantity
          requestItemStatus {
            label
            color
          }
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            images {
              fileCategoryName
              fileCategoryDisplayName
              fileUrl
              fileName
            }
            customFields {
              values
              fieldTypeName
              fieldTypeDisplayName
              isMultiple
            }
          }
          requests {
            id
            requestStatus {
              label
              color
            }
          }
          requestItems {
            id
            receivedQuantity
          }
          receivedQuantity: issuedQuantity
        }
        nodeItems {
          id
          nodeId
          nodeName
          quantity
          bayType
          requestItemId
        }
      }
    }
  }
`;

export const REPLACE_ISSUE_REQUEST_ITEM_V2 = gql`
  mutation ReplaceIssueRequestItemV2(
    $entityId: String!
    $requestId: String!
    $issueRequestItemId: String!
    $updatedProductId: String!
  ) {
    replaceIssueRequestItemV2(
      entityId: $entityId
      requestId: $requestId
      issueRequestItemId: $issueRequestItemId
      updatedProductId: $updatedProductId
    ) {
      request {
        id
        requestItems {
          id
          quantity
          action
          status
          inStockQuantity
          totalConfirmedQuantity
          totalReservedQuantity
          requestItemStatus {
            label
            color
          }
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            images {
              fileCategoryName
              fileCategoryDisplayName
              fileUrl
              fileName
            }
            customFields {
              values
              fieldTypeName
              fieldTypeDisplayName
              isMultiple
            }
          }
          requests {
            id
            requestStatus {
              label
              color
            }
          }
          requestItems {
            id
            receivedQuantity
          }
          receivedQuantity: issuedQuantity
        }
        nodeItems {
          id
          nodeId
          nodeName
          quantity
          bayType
          requestItemId
        }
      }
      success
    }
  }
`;

export const REPLACE_ISSUE_REQUEST_ITEM = gql`
  mutation ReplaceIssueRequestItem(
    $entityId: String!
    $requestId: String!
    $requestItemId: String!
    $updatedProductId: String!
  ) {
    replaceIssueRequestItem(
      entityId: $entityId
      requestId: $requestId
      requestItemId: $requestItemId
      updatedProductId: $updatedProductId
    ) {
      request {
        id
        requestItems {
          id
          quantity
          action
          status
          inStockQuantity
          totalConfirmedQuantity
          totalReservedQuantity
          requestItemStatus {
            label
            color
          }
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            images {
              fileCategoryName
              fileCategoryDisplayName
              fileUrl
              fileName
            }
            customFields {
              values
              fieldTypeName
              fieldTypeDisplayName
              isMultiple
            }
          }
          requests {
            id
            requestStatus {
              label
              color
            }
          }
          requestItems {
            id
            receivedQuantity
          }
          receivedQuantity: issuedQuantity
        }
        nodeItems {
          id
          nodeId
          nodeName
          quantity
          bayType
          requestItemId
        }
      }
      success
    }
  }
`;

export const REORDER_REQUEST_ITEM = gql`
  mutation reorderRequestItem(
    $entityId: String!
    $issueRequestId: String!
    $issueRequestItems: [IssueRequestItemQuantityInput!]!
  ) {
    addIssueRequestItemToPurchaseRequest(
      entityId: $entityId
      issueRequestId: $issueRequestId
      issueRequestItems: $issueRequestItems
    ) {
      success
      request {
        id
        action
        requestItems {
          id
        }
      }
    }
  }
`;

export const GET_ALL_PRODUCTS_FOR_RECOMMENDATION = gql`
  query GetAllProductsListing(
    $filters: [FilterInputType!]
    $entityId: String!
  ) {
    getAllProducts(filters: $filters, entityId: $entityId) {
      data {
        id
        productName
        partNumber
        brand {
          id
          brandName
        }
      }
      paginator {
        totalItems
      }
    }
  }
`;

export const GET_ACTIVITY_LOGS = gql`
  query getRequestNodeItemActivities(
    $entityId: String!
    $requestId: String!
    $nodeItemId: String!
  ) {
    getRequestNodeItemActivities(
      entityId: $entityId
      requestId: $requestId
      nodeItemId: $nodeItemId
    ) {
      id
      createdAt
      user {
        username
      }
      reason
      action
      metaData
      metaDataProductDetails {
        productName
        partNumber
        type
      }
      requestNodeItem {
        requestItem {
          product {
            productName
            partNumber
          }
        }
      }
    }
  }
`;

export const GET_ISSUE_REQUEST = gql`
  query getRequest(
    $entityId: String!
    $requestId: String!
    $returnClosed: Boolean
  ) {
    getRequest(entityId: $entityId, requestId: $requestId) {
      id
      slug
      displayName
      mmvyValue
      mmvy {
        id
        displayName
        engineType
        variantName
        dateStart
        dateEnd
        modelName
      }
      status
      source
      sourceId
      reason
      action
      requestType
      sourceDetails {
        leadId
        make
        model
        variant
        registrationNo
        transmission
        year
        fuelType
        chassisNo
        procCategory
        month
        variantId
      }
      requestItems {
        id
        quantity
        action
        status
        availableQuantity
        inStockQuantity
        totalConfirmedQuantity
        totalReservedQuantity
        remainingPurchaseRequestItemsForIssue
        isReplaceable
        isReplaceableV1
        isReorderable
        isReserved
        rejectedByReason
        isReturnedAsWrongPart
        requestItemStatus {
          label
          color
        }
        product {
          id
          productName
          partNumber
          size
          mrp
          isLooseItem
          images {
            fileCategoryName
            fileCategoryDisplayName
            fileUrl
            fileName
          }
          customFields {
            values
            fieldTypeName
            fieldTypeDisplayName
            isMultiple
          }
        }
        requests {
          id
          requestStatus {
            label
            color
          }
        }
        requestItems {
          id
          receivedQuantity
        }
        receivedQuantity: issuedQuantity
      }
      nodeItems(returnClosed: $returnClosed) {
        id
        nodeId
        nodeName
        quantity
        bayType
        priority
        requestItemId
        media
        standardPartName
        categoryId
        isSkuHardReserved
        requestItem {
          requestItems {
            id
            totalConfirmedQuantity
          }
        }
        requestNodeItemStatus {
          label
          color
        }
      }
    }
  }
`;
export const GET_ALL_MEASUREMENT_UNIT = gql`
  query getAllMeasurementUnit($entityId: String!) {
    getAllMeasurementUnits(entityId: $entityId) {
      name
      displayName
    }
  }
`;

export const UPDATE_REQUEST_ITEM_TO_VENDOR = gql`
  mutation UpdateRequestItemToVendor(
    $entityId: String!
    $requestItemId: String!
    $vendorId: String!
    $confirmedQuantity: Int
  ) {
    updateRequestItemToVendor(
      entityId: $entityId
      requestItemId: $requestItemId
      vendorId: $vendorId
      confirmedQuantity: $confirmedQuantity
    ) {
      success
      requestItemToVendor {
        id
        requestItem {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          totalConfirmedQuantity
          totalReservedQuantity
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            brand {
              id
              brandName
            }
          }
          requests {
            id
            source
            sourceId
            slug
            sourceDetails {
              leadId
              make
              model
              variant
              registrationNo
              transmission
              year
              fuelType
            }
          }
          requestItems {
            id
            receivedQuantity
          }
          receivedQuantity
        }
      }
    }
  }
`;

export const DELETE_VENDOR = gql`
  mutation DeleteVendorRequestItem(
    $entityId: String!
    $requestId: String!
    $requestItemId: String!
    $vendorId: String!
  ) {
    deleteVendorRequestItem(
      entityId: $entityId
      requestId: $requestId
      requestItemId: $requestItemId
      vendorId: $vendorId
    ) {
      success
      requestItem {
        id
        vendors {
          id
          name
          contactDetails {
            id
            name
            contactNumber
          }
        }
      }
    }
  }
`;

export const REPLACE_PURCHASE_REQUEST_ITEM_FOR_REQUEST_TYPES = gql`
  mutation ReplacePurchaseRequestItem(
    $entityId: String!
    $requestId: String!
    $requestItemId: String!
    $updatedProductId: String!
  ) {
    replacePurchaseRequestItem(
      entityId: $entityId
      requestId: $requestId
      requestItemId: $requestItemId
      updatedProductId: $updatedProductId
    ) {
      success
      request {
        id
        slug
        displayName
        status
        source
        sourceId
        reason
        action
        requestType
        sourceDetails {
          leadId
          make
          model
          variant
          registrationNo
          transmission
          year
          fuelType
        }
        requestItems {
          id
          vendors {
            id
            name
            contactDetails {
              id
              name
              contactNumber
            }
          }
          quantity
          action
          status
          inStockQuantity
          totalConfirmedQuantity
          totalReservedQuantity
          requestItemStatus {
            label
            color
          }
          product {
            id
            productName
            partNumber
            size
            mrp
            isLooseItem
            images {
              fileCategoryName
              fileCategoryDisplayName
              fileUrl
              fileName
            }
            customFields {
              values
              fieldTypeName
              fieldTypeDisplayName
              isMultiple
            }
            brand {
              id
              brandName
            }
          }
          requests {
            id
            source
            sourceId
            slug
            sourceDetails {
              leadId
              make
              model
              variant
              registrationNo
              transmission
              year
              fuelType
            }
          }
          requestItems {
            id
            receivedQuantity
          }
          receivedQuantity
        }
      }
    }
  }
`;

export const GET_INVENTORY_ACTIVITIES_FOR_REQUEST_ITEM = gql`
  query getInventoryActivitiesForRequestItem(
    $entityId: String!
    $requestId: String!
    $requestItemId: String!
  ) {
    getInventoryActivitiesForRequestItem(
      entityId: $entityId
      requestId: $requestId
      requestItemId: $requestItemId
    ) {
      createdAt
      createdByUser {
        username
      }
      productSku {
        sku
        document {
          documentNumber
          documentType
          vendor {
            name
          }
        }
        mrp
        tax
        listingPrice
        landingCost
      }
    }
  }
`;

export const GET_ISSUE_BUTTON_STATUS = gql`
  query getIssueButtonStatus($entityId: String!, $requestId: String!) {
    getIssueButtonStatus(entityId: $entityId, requestId: $requestId) {
      requestId
      nodeData {
        nodeId
        isMjrCreated
      }
    }
  }
`;

export const GET_REJECTED_PRODUCT_SKUS = gql`
  query getRejectedProductSkus(
    $entityId: String!
    $search: String
    $page: Int
    $filters: [FilterInputType!]
  ) {
    getRejectedProductSkus(
      entityId: $entityId
      search: $search
      page: $page
      filters: $filters
    ) {
      data {
        sku
        id
        sellingPrice
        mrp
        returnFeedbackImages
        currentLocation {
          locationName
          locationDisplayName
        }
        product {
          id
          partNumber
          productName

          isLooseItem
          brand {
            brandName
          }
        }
        unit
        document {
          vendor {
            name
          }
        }
        createdAt
        issueRequestId
        isReserved
        qcWrongPartVerdictGiven
        __typename
      }
      paginator {
        numPages
        currentPage
        perPage
      }
    }
  }
`;

export const GET_QC_REASON = gql`
  query GetQcReasons {
    getQcReasons {
      wrongPartRack
      damagedPartRack
      notRequired
      unidentifiedPart
      __typename
    }
  }
`;

export const IMAGE_UPLOAD_PERFORM_QC = gql`
  query get_actionables($qcReason: String!) {
    getActionablesForQcReason(qcReason: $qcReason) {
      isPhotoRequired
      allowRackChange
      allowStockOut
    }
  }
`;

// export const UPLOAD_RETURNED_PART = gql`
// mutation uploadReturnPart(
//   fileUploadSlugs,
//   productSkuId){
//     uploadReturnedPartImage(
//       fileUploadSlugs:$imageSlug,
//       productSkuId: $productSkuId){
//         success
//   }
// `

// export const UPLOAD_RETURNED_PART = gql`
//   mutation uploadReturnedPartImage($fileUploadSlugs:String!, $productSkuId:String!){
//     uploadReturnedPartImage(fileUploadSlugs: $fileUploadSlugs , productSkuId:$productSkuId){
//       fileUploadSlugs
//       productSkuId
//     }
//   }
// `;

export const UPLOAD_RETURNED_PART = gql`
  mutation uploadReturnedPartImage(
    $fileUploadSlugs: [String!]
    $productSkuId: String!
    $entityId: String!
  ) {
    uploadReturnedPartImage(
      fileUploadSlugs: $fileUploadSlugs
      productSkuId: $productSkuId
      entityId: $entityId
    ) {
      success
    }
  }
`;
